import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { environment } from '../../../environments/environment';
import { Headers, RequestOptions } from '@angular/http';
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthenticationService {

    constructor(private http: Http) {
    }

    login(email: string, password: string) {

        let headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: headers });

        var body = 'username=' + email + '&password=' + password + '&client_secret=medapp&client_id=medapp&grant_type=password';


        return this.http.post(environment.apiUrl + 'oauth/token', body, options)
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let user = response.json();
                console.log(user);
                if (user && user.access_token) {
                    user.role = user.userdata.role_slug;
                    if (user.userdata.is_parent_user_account) {
                        user.role = "parent_primary";
                    }
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));

                    if (user.userdata.athletes && user.userdata.athletes[0]) { //get association and club info
                        var athleteObj = user.userdata.athletes[0];
                        var associationObj: any = {};
                        associationObj.association_id = athleteObj.association_id;
                        associationObj.association_name = athleteObj.association_name;
                        associationObj.association_subtitle = athleteObj.association_subtitle;
                        associationObj.association_logo = athleteObj.association_logo;

                        console.log(associationObj);

                        var club_list = [];

                        // Calls getClubs function takes data and adds it to localStorage
                        
                        this.getClubs(user.access_token, associationObj.association_id).subscribe((data) => {
                          club_list = club_list.concat(data.data);
                          localStorage.setItem('sg_club_list', JSON.stringify(club_list));
                          return data.data;
                        });

                        var clubObj: any = {};
                        clubObj.club_id = athleteObj.club_id;
                        clubObj.club_website = athleteObj.club_website;

                        var teamObj: any = {};
                        teamObj.team_id = athleteObj.team_id;

                        localStorage.setItem('sg_association_data', JSON.stringify(associationObj));
                        localStorage.setItem('sg_club_data', JSON.stringify(clubObj));
                        localStorage.setItem('sg_team_data', JSON.stringify(teamObj));
                    }


                }
            });
    }

    getClubs(token: string, associationId: string): Observable<any> {
      let headers = new Headers({
        'Content-Type': 'application/json',
        'access_token': token
      });
      let options = new RequestOptions({ headers: headers });
      let url = environment.apiUrl + `association/${associationId}/clubs`

       return this.http.get(url, options).map((response: Response) => {
         return response.json();
       });
    }

    activate(token: string, password: string, confirm_password: string): Observable<any> {

        if (!password) {
            return Observable.throw('Password must be at least 8 characters');
        }

        if (password != confirm_password) {
            return Observable.throw('Passwords do not match');
        }

        if (password.length < 8) {
            return Observable.throw('Password must be at least 8 characters');
        }


        let headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: headers });

        var body = 'password=' + password;


        return this.http.post(environment.apiUrl + 'activate_account/' + token, body, options)
            .map((response: Response) => {
                console.log(response);
                // login successful if there's a jwt token in the response
                let user = response.json();
                console.log(user);
                localStorage.setItem('username', JSON.stringify(user.message.username));
                return user;
            });
    }

    searchAccount(email: string, lastname: string, dob: string): Observable<any> {
        console.log(email + " " + lastname + " " + dob);


        if (!email) {
            return Observable.throw('Email address is required');
        }

        if (!lastname) {
            return Observable.throw('Last Name is required');
        }

        if (!dob) {
            return Observable.throw('Date of Birth is required');
        }



        let headers = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: headers });

        var body = 'email=' + email;
        body += '&lastname=' + lastname;
        body += '&dob=' + dob;


        return this.http.post(environment.apiUrl + 'search_account', body, options)
            .map((response: Response) => {
                console.log(response);
                // login successful if there's a jwt token in the response
                let responseJSON = response.json();
                var message = "";
                if (responseJSON.message && responseJSON.message[0]) {
                    message = responseJSON.message[0];
                }

                return message;
            });

    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts